import styled from "styled-components";

const MasterTable = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  @media(max-width: 500px) {
    grid-template-columns: 1fr 1fr;
  }
  @media(max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

export default MasterTable;
